import React, { useMemo } from 'react';

import { Typography } from '@mui/material';
import { useState } from 'react';

import { VictoryAxis, VictoryLegend, VictoryBar, VictoryChart, VictoryGroup, VictoryTheme, VictoryTooltip } from 'victory';

export function Statistics({
  labels,
  data,
  labelKey,
  xKey,
  onRowClick,
  yKey,
  legend,
  series,
  xTickFormat,
  xTickValues,
  yTickFormat,
  tickFormat,
  style
}) {
  var primary = "#000000";

  const maxValue = useMemo(() => {
    let max = 0
    if (!data?.stats) {
      return max
    }
    for (let row of data.stats) {
      const value = yKey instanceof Function ? yKey(row) : row[yKey]
      max = Math.max(max, parseFloat(value ?? 0) ?? 0)
    }
    console.log("max", max)
    return max
  }, [data?.stats])

  const yTickValues = useMemo(() => {
    const ret = Array(5).fill().map((n, i) => (maxValue / 4) * i)
    return ret
  }, [maxValue])

  console.log("yTickValues", yTickValues)

  const [zoomDomain] = useState({ x: labels, y: [0, maxValue] })

  if (!data?.stats) {
    return <Typography>No stats</Typography>
  }

  return (
    <VictoryChart
      theme={VictoryTheme.clean}
      responsive={true}
      scale={{
        x: "time",
        y: { 
          domainMax: maxValue 
        }
      }}
      tickFormat={tickFormat}
      height={250}
    >
      {legend && <VictoryLegend
        x={20}
        style={{
          labels: {
            fontWeight: 'bold',
            fontFamily: 'DM Sans',
            fontSize: 6
          }
        }}
        data={legend}
      />}
      <VictoryAxis
        tickValues={xTickValues}
        tickFormat={xTickFormat}
        style={{
          axisLabel: {
            fontSize: 6,
            fontWeight: 'bold',
            fontFamily: "DM Sans",
            fill: 'black'
          },
          tickLabels: {
            fontSize: 6,
            fontWeight: 'bold',
            fontFamily: "DM Sans",
            fill: 'black'
          },
          ...style
        }}
      />
      <VictoryAxis
        fixLabelOverlap={false}
        tickValues={yTickValues}
        tickFormat={yTickFormat}
        dependentAxis
        style={{
          grid: { stroke: 'rgba(127, 127, 127, .3)', strokeWidth: 0.5 },
          axisLabel: {
            fontWeight: 'bold',
            fontSize: 5,
            fontFamily: "DM Sans",
            fill: 'black'
          },
          tickLabels: {
            fontSize: 6,
            fontWeight: 'bold',
            fontFamily: "DM Sans",
            fill: 'black'
          }
        }}
      />
      {series?.length > 0 ? (
        <VictoryGroup
          offset={8}
        >
          {series?.map(serie => (
            <VictoryBar
              events={[
                {
                  childName: 'bar',
                  target: 'data',
                  eventHandlers: {
                    onClick: (evt) => {
                      evt.stopPropagation();
                      return [
                        {
                          mutation: (props) => {
                            onRowClick?.(props.datum)
                          },
                        },
                      ];
                    }
                  }
                }
              ]}
              labelComponent={
                <VictoryTooltip style={{ fontSize: 7, fontWeight: 'bold', fontFamily: 'DM Sans' }} />
              }
              key={serie.id}
              data={data.stats.map(n => ({
                ...n,
                x: serie.xKey instanceof Function ? serie.xKey(n) : n[serie.xKey],
                y: serie.yKey instanceof Function ? serie.yKey(n) : n[serie.yKey]
              }))}
              labels={({ datum }) => labelKey instanceof Function ? labelKey(datum) : datum[labelKey]}
              style={serie.style}
            />
          ))}
        </VictoryGroup>
      ) : (labelKey && yKey ? ( 
        <VictoryBar
          labelComponent={<VictoryTooltip style={{ fontSize: 7, fontWeight: 'bold', fontFamily: 'DM Sans' }} />}
          labels={(o) => labelKey instanceof Function ? labelKey(o) : o[labelKey]}
          barRatio={0}
          data={data.stats.map(n => ({
            ...n,
            label: labelKey instanceof Function ? labelKey(n) : n[labelKey],
            x: xKey instanceof Function ? xKey(n) : n[xKey],
            y: yKey instanceof Function ? yKey(n) : n[yKey]
          }))}
          interpolation="linear"
          x={(value) => xKey instanceof Function ? xKey(value) : value[xKey]}
          y={(value) => yKey instanceof Function ? yKey(value) : value[yKey]}
        /> 
      ): null)}
    </VictoryChart>
  )
}